export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.6b5a89909e8428d8de6ebb0a9950bdea.css";